import {Box, Skeleton} from '@mui/material';

import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

const cardSx = {
  border: '0.5px solid',
  borderColor: 'divider',
  borderRadius: '14px',
  px: 2.5,
  py: 2.25,
  mb: 2,
} as const;

export interface Props {
  embedded?: boolean;
}

export const DepartmentHealthProfileDecisionGuideSkeleton = ({embedded = false}: Props) => {
  const resolvedCardSx = embedded ? {...cardSx, mb: 0} : cardSx;

  return (
    <EmpionPaper sx={resolvedCardSx}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5}}>
        <Skeleton variant='circular' width={15} height={15} />
        <Skeleton variant='text' width={160} height={18} />
      </Box>
      <Skeleton variant='text' width='85%' height={14} sx={{mb: 2}} />
      <Box sx={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2}}>
        <Skeleton variant='rounded' height={88} sx={{borderRadius: '10px'}} />
        <Skeleton variant='rounded' height={88} sx={{borderRadius: '10px'}} />
      </Box>
      <Skeleton variant='text' width={180} height={12} sx={{mb: 1}} />
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.625, mb: 2}}>
        {Array.from({length: 4}).map((_, index) => (
          <Skeleton key={index} variant='rounded' width={72} height={24} sx={{borderRadius: '6px'}} />
        ))}
      </Box>
      <Skeleton variant='text' width={140} height={12} sx={{mb: 1}} />
      <Skeleton variant='rounded' height={96} sx={{borderRadius: '10px', mb: 1.25}} />
      <Skeleton variant='rounded' height={36} sx={{borderRadius: '8px'}} />
    </EmpionPaper>
  );
};
